/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SuggestionReasonFromJSON, SuggestionReasonToJSON, } from './SuggestionReason';
import { FileOrFolderFromJSON, FileOrFolderToJSON, } from './FileOrFolder';
/**
 * Check if a given object implements the Suggestion interface.
 */
export function instanceOfSuggestion(value) {
    if (!('file' in value) || value['file'] === undefined)
        return false;
    if (!('reason' in value) || value['reason'] === undefined)
        return false;
    return true;
}
export function SuggestionFromJSON(json) {
    return SuggestionFromJSONTyped(json, false);
}
export function SuggestionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'file': FileOrFolderFromJSON(json['file']),
        'reason': SuggestionReasonFromJSON(json['reason']),
        'groupName': json['group_name'] == null ? undefined : json['group_name'],
    };
}
export function SuggestionToJSON(json) {
    return SuggestionToJSONTyped(json, false);
}
export function SuggestionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'file': FileOrFolderToJSON(value['file']),
        'reason': SuggestionReasonToJSON(value['reason']),
        'group_name': value['groupName'],
    };
}
